import { render, staticRenderFns } from "./PartyHistory.vue?vue&type=template&id=a3a80332&scoped=true"
import script from "./PartyHistory.vue?vue&type=script&lang=js"
export * from "./PartyHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3a80332",
  null
  
)

export default component.exports